import React from 'react';
import { Link } from 'react-router-dom';

const TrainingProviderCard = ({ logo_img, academy_name = "", first_name, last_name, name = "", location = { city: "", state: "", country: "" }, clients_coached = "", about_description = "", certification_tags = [], institution_type = "", experience_yrs = 1, languages, training_types, courses_and_affiliations, phone_no = "0000000000", id: trainerId = null, availability = "Online/Offline", ...trainerProps }) => {

    // const user_name = getFullName({ first_name: first_name, last_name: last_name })

    const locality = `${!!location?.city ? location?.city + ', ' : ''}${!!location?.state ? location?.state + ', ' : ''}${!!location?.country ? location?.country : ''}`;

    const LocationAndAmenities = () => {
        return (
            <div className='flex-grow flex flex-1 flex-row justify-between items-start md:gap-x-6'>
                <div className='w-full flex-1 flex flex-col items-start py-2 md:py-0 gap-1'>
                    <p className="text-gray-300 text-sm font-medium">Institution Type</p>
                    <p className="text-[0.75rem] text-gray-400 leading-relaxed line-clamp-4">
                        {institution_type}
                    </p>
                </div>
                {/* Contact Now Button (Right-aligned) */}
                <div className='hidden md:flex items-center justify-end mt-2'>
                    <ContactButton />
                </div>
            </div>
        )
    }

    const ContactButton = () => {
        return (
            <a
                onClick={(e) => {
                    e.stopPropagation(); // ⛔ stop parent click
                }}
                href={`tel:${phone_no}`}
                className="flex-shrink-0 group flex items-center bg-white border border-gray-300 text-gray-900 font-medium p-[0.15rem] rounded-[0.6rem] rounded-tr-[0.3rem] shadow-sm hover:scale-105 focus:outline-none focus:ring-2 focus:ring-offset-2 transition duration-200"
            >
                <span className="hidden md:flex px-2 font-urbanist text-xs font-semibold mr-1">Contact Now</span>
                <span className="flex items-center justify-center w-5 h-5 bg-black rounded-[0.53rem] rounded-tr-[0.3rem] p-1">
                    <img
                        className="transition-transform group-hover:scale-105"
                        src="/assets/individual/Call.png"
                        alt="Contact"
                    />
                </span>
            </a>
        )
    }

    return (
        <div className="bg-gradient-radial p-3 rounded-xl font-urbanist flex flex-row w-full max-w-6xl mx-auto mb-6 gap-3 shadow-lg shadow-[#171A26] hover:shadow-lg hover:scale-[1.01] transition-transform duration-200 border-t border-gray-900">
            <div className="w-full flex flex-col justify-center items-start">
                <div className="w-full flex flex-row justify-center items-start gap-3 mb-3 md:mb-3">
                    {/* Gym Image */}
                    <div className="flex-shrink-0 w-20 h-20 rounded-2xl rounded-tr-md overflow-hidden bg-gray-700 flex items-center justify-center">
                        {/* Placeholder for actual image */}
                        <img src={logo_img} alt="Training Provider" className="w-full h-full object-cover" />
                    </div>

                    {/* Column 1: Name, Assured Tag, Description */}
                    <div className="flex flex-1 flex-row flex-wrap md:flex-nowrap items-start md:gap-7">
                        <div className="flex flex-1 flex-col items-start mb-1">
                            <div className="text-md font-medium text-white">{academy_name}</div>
                            <p className="text-[0.75rem] text-gray-400 leading-relaxed line-clamp-1">
                                {locality}
                            </p>
                        </div>
                        <div className="hidden md:flex md:w-[55.5%] flex-row justify-between">
                            <LocationAndAmenities />
                        </div>
                    </div>
                </div>
                {/* Main Content Area */}
                <div className='md:hidden flex flex-col items-start'>
                    <LocationAndAmenities />
                </div>
                <div className="w-full flex flex-col md:flex-row justify-between">
                    <div className='w-full md:w-1/2 flex flex-col items-start py-2 md:py-0 gap-1'>
                        <p className="text-gray-300 text-sm font-medium">Our Courses</p>
                        <p className="text-[0.75rem] text-gray-400 leading-relaxed line-clamp-4">
                            {(courses_and_affiliations?.courses || []).join(', ')}
                        </p>
                    </div>
                    <div className='w-full md:w-1/2 flex flex-col items-start py-2 md:py-0 gap-1'>
                        <p className="text-gray-300 text-sm font-medium">Our Branches</p>
                        <p className="text-[0.75rem] text-gray-400 leading-relaxed line-clamp-4">
                            {(courses_and_affiliations?.branches || []).join(', ')}
                        </p>
                    </div>
                </div>
            </div>

            <div className='md:hidden flex flex-col'>
                <ContactButton />
            </div>
        </div >
    );
};

export { TrainingProviderCard };